import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultView from "../../V2/ResultView";

export function B29({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FSTR01.error_id: {
            return (
                <>
                    <ResultText>
                        {row?.data?.map(r => (
                            <>
                                <ResultText>
                                    The flow rate is different at the US and DS cross sections of {r?.culvert_type} at RS {<CheckCSName csName={r?.cross_section} />} for {r?.profiles?.join(', ')} profiles.
                                    <EmptyLine />
                                </ResultText>
                                {
                                    (r?.us || r?.ds) && (
                                        <ResultTable>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                                    <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Section</ResultHeaderCell>
                                                    {
                                                        r?.profiles?.map(p => (
                                                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                                                {p}
                                                            </ResultHeaderCell>
                                                        ))
                                                    }
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                {
                                                    r?.us && (
                                                        <ResultRow>
                                                            <ResultBodyCell>
                                                                <CheckCSName csName={r?.us?.cross_section} />
                                                            </ResultBodyCell>
                                                            <ResultBodyCell style={{textAlign: 'right'}}>
                                                                US
                                                            </ResultBodyCell>
                                                            {
                                                                r?.us?.data?.map(x => (
                                                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                                                        {x}
                                                                    </ResultBodyCell>
                                                                ))
                                                            }
                                                        </ResultRow>
                                                    )
                                                }

                                                <ResultRow>
                                                    <ResultBodyCell>
                                                        {r?.culvert_name || '-'}
                                                    </ResultBodyCell>
                                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                                        {r?.culvert_type || '-'}
                                                    </ResultBodyCell>
                                                    {
                                                        r?.profiles?.map(x => (
                                                            <ResultBodyCell style={{textAlign: 'right'}}>
                                                            </ResultBodyCell>
                                                        ))
                                                    }
                                                </ResultRow>

                                                <ResultRow>
                                                    <ResultBodyCell>
                                                        <CheckCSName csName={r?.ds?.cross_section || '-'} />
                                                    </ResultBodyCell>
                                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                                        DS
                                                    </ResultBodyCell>
                                                    {
                                                        r?.ds?.data?.map(x => (
                                                            <ResultBodyCell style={{textAlign: 'right'}}>
                                                                {x}
                                                            </ResultBodyCell>
                                                        ))
                                                    }
                                                </ResultRow>
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                            </>
                        ))}
                    </ResultText>
                </>
            )
        }
    }
}